import React from 'react';
import {Link} from 'react-router-dom';

import colours from 'styles/colours';
import {FORGOTTEN_PASSWORD_URL} from 'paths';

export default function ForgotPasswordLink() {

    const forgotPasswordStyles = {
        color: colours.font.link,
        marginBottom: 15,
        marginTop: 15,
    };

    return <Link to={FORGOTTEN_PASSWORD_URL} style={forgotPasswordStyles} id="forgotten-password">
        &gt; &gt; &nbsp;Forgot your password
    </Link>;
}